import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '@mulesoft/anypoint-icons/lib/svg/info.svg';
import styles from './TabPanelReview.css';

const TabPanelReview = ({
  title,
  subtitle,
  typeStyle,
  agents,
  region,
  typeMsg,
  typeMsgStyle,
  displayWarning = false
}) => {
  return (
    <div data-test-id="scan-tab-panel-section">
      <div className={styles.reviewSectionTitle}>
        <p className={styles.reviewInfoLabel}>{title}</p>
        <p>{subtitle}</p>
      </div>
      <div display-if={agents.length > 0}>
        {agents.map((item) => (
          <div
            key={item.name}
            className={`${styles.reviewSectionContent} ${typeStyle}`}
          >
            <div className={styles.reviewInfoGrid}>
              <div className={styles.reviewInfoItem}>
                <span>
                  <span className={styles.reviewInfoLabel}>{item.name}</span>
                  <span className={styles.reviewInfoItemSkill}>
                    {item.version}
                  </span>
                  <span className={`${typeMsgStyle}`}>{typeMsg}</span>
                  <span className={styles.reviewInfoType}>
                    {item.agentCard.provider.organization}
                  </span>
                </span>
                <span className={styles.reviewInfoTarget}>
                  {item.description}
                </span>
                <span
                  className={styles.reviewInfoWarningError}
                  display-if={displayWarning}
                >
                  <InfoIcon />
                  <strong>Impact Analysis:</strong> Something went wrong in the
                  scan run. Will retry in next scan.
                </span>
              </div>
              <div className={styles.reviewInfoItem}>
                <div className={styles.reviewInfoItemDetails}>
                  <div className={styles.reviewInfoGrid}>
                    <div className={styles.reviewInfoItem}>Platform</div>
                    <div className={styles.reviewInfoItem}>
                      {item.agentCard.provider.organization}
                    </div>
                  </div>
                  <div className={styles.reviewInfoGrid}>
                    <div className={styles.reviewInfoItem}>
                      Foundation model
                    </div>
                    <div className={styles.reviewInfoItem}>{}</div>
                  </div>
                  <div className={styles.reviewInfoGrid}>
                    <div className={styles.reviewInfoItem}>Agent ID</div>
                    <div className={styles.reviewInfoItem}>{item.assetId}</div>
                  </div>
                  <div className={styles.reviewInfoGrid}>
                    <div className={styles.reviewInfoItem}>Region</div>
                    <div className={styles.reviewInfoItem}>{region}</div>
                  </div>
                  <div className={styles.reviewInfoGrid}>
                    <div className={styles.reviewInfoItem}>Skills</div>
                    <div
                      display-if={
                        item.agentCard.skills &&
                        item.agentCard.skills.length > 0
                      }
                    >
                      {item.agentCard.skills.map((skillItem) => (
                        <span
                          key={skillItem.name}
                          className={styles.reviewInfoItemSkill}
                        >
                          {skillItem.name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

TabPanelReview.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  typeStyle: PropTypes.string,
  agents: PropTypes.array,
  region: PropTypes.string,
  typeMsg: PropTypes.string,
  typeMsgStyle: PropTypes.string,
  displayWarning: PropTypes.bool
};

export default TabPanelReview;
